/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

export const getImageTags = img => {
  if (!img) {
    return []
  }

  const { session = '', tags = [], track_sector = '' } = img || {}
  const { car_model, car_orientation } = tags[0] || {}
  return [car_model, car_orientation, session, track_sector].filter(el => !!el && el !== 'n/a')
};
